import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import Dashboard from "./pages/Dashboard";
import TestPage from "./pages/TestPage";
import HealthCheck from "./pages/HealthCheck";
import LegalPage from "./pages/LegalPage";
import PrivacyPage from "./pages/PrivacyPage";
import NotFoundPage from "./pages/NotFoundPage";
import ProtectedRoute from "./components/ProtectedRoute";
import { AuthProvider } from "./contexts/Auth";
import ShareLanding from "./components/ShareLanding";
import ForSchools from "./pages/ForSchools";
import AboutPage from "./pages/AboutPage";
import EmbedPage from "./pages/EmbedPage";
import EmbedGeneratorPage from "./pages/EmbedGeneratorPage";
import CoursePage from "./pages/CoursePage";
import PublicCoursePage from "./pages/PublicCoursePage";
import TeachPage from "./pages/TeachPage";
import TeachCoursePage from "./pages/TeachCoursePage";

function App() {
    return (
        <AuthProvider>
            <Router>
                <Routes>
                    {/* Embed route - outside Layout (no header/footer) */}
                    <Route path="/embed" element={<EmbedPage />} />

                    <Route path="/test" element={<TestPage />} />
                    <Route path="/login" element={<LoginPage />} />
                    <Route path="/register" element={<RegisterPage />} />
                    <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                    <Route path="/reset-password/:uid/:token" element={<ResetPasswordPage />} />
                    <Route element={<Layout />}>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/legal" element={<LegalPage />} />
                        <Route path="/privacy" element={<PrivacyPage />} />
                        <Route
                            path="/dashboard"
                            element={
                                <ProtectedRoute>
                                    <Dashboard />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/courses/:courseId"
                            element={
                                <ProtectedRoute>
                                    <CoursePage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/teach"
                            element={
                                <ProtectedRoute>
                                    <TeachPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/teach/:courseId"
                            element={
                                <ProtectedRoute>
                                    <TeachCoursePage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/healthcheck"
                            element={
                                <ProtectedRoute>
                                    <HealthCheck />
                                </ProtectedRoute>
                            }
                        />
                        <Route path="/share/:shareCode" element={<ShareLanding />} />
                        <Route path="/c/:code" element={<PublicCoursePage />} />
                        <Route path="/for-schools" element={<ForSchools />} />
                        <Route path="/about" element={<AboutPage />} />
                        <Route path="/embed/generate" element={<EmbedGeneratorPage />} />
                        {/* 404 Catch-all route - must be last */}
                        <Route path="*" element={<NotFoundPage />} />
                    </Route>
                </Routes>
            </Router>
        </AuthProvider>
    );
}

export default App;
